module.exports = __webpack_public_path__ + "static/media/foto1.7e576a86.png";